import { useState,useRef,useEffect } from "react";
import emailjs from '@emailjs/browser';
import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapPin, Phone, Mail } from 'lucide-react'; 
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaYoutube } from 'react-icons/fa'; // Import ikon dari react-icons
import { message as messages,Spin } from 'antd';

// Tambahkan icon leaflet untuk marker
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [messageApi, contextHolder] = messages.useMessage();
  const [loading, setLoading] = useState(false);
  const locationRef = useRef(null);

  // Use effect to set up the Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible'); // Add the class when in view
        } else {
          entry.target.classList.remove('visible'); // Remove class when out of view
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.5, // Adjust threshold as necessary
    });

    const heading = locationRef.current; // Get the heading element
    if (heading) {
      observer.observe(heading); // Observe the heading
    }

    return () => {
      if (heading) {
        observer.unobserve(heading); // Clean up the observer on component unmount
      }
    };
  }, []);

  const form = useRef();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  
  const clearState = () => setState({ ...initialState });
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const templateParams = {
      name,
      email,
      message,
    };
  
    try {
      await emailjs.send(
        "service_i3zn36e",   // ← ganti dengan Service ID dari EmailJS
        "template_od3gjta",  // ← ganti dengan Template ID dari EmailJS
        templateParams,
        "FclTw6pqnhEtwCizI"    // ← ganti dengan Public Key dari EmailJS
      );
  
      messageApi.success("Your message has been sent successfully!");
      clearState();
      e.target.reset();
  
    } catch (error) {
      console.error("Error:", error);
      messageApi.error("Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
 
  


  // Koordinat alamat
  const position = [-6.2311785, 106.9022103];

  return (
    <>
    <div id="Kontak">
      <div className="contact-container">
        <div className="form-section">
          <h2>Get in touch</h2>
          <p>We are here for you! How can we help?</p>
          <form className="contact-form" ref={form} onSubmit={handleSubmit}>
            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              placeholder="Enter your name"
              name="name"
              value={name}
              onChange={handleChange}
              required
            />
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              name="email"
              value={email}
              onChange={handleChange}
              required
            />
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              placeholder="Enter your message"
              name="message"
              value={message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit" disabled={loading}>
              {loading ? <Spin size="small" /> : 'Submit'}
            </button>
          </form>
        </div>

        <div className="contact-info">
          <div className="contact-image">
            <img src="img/contact.svg" alt="Contact Us" />
          </div>
        </div>
      </div>

     {/* Peta dengan Leaflet */}
<div className='leaflet-container'>
<h2 className="contact-title fade-in-left" ref={locationRef}>Our Location</h2>
  <MapContainer center={[-6.19079, 106.85659]} zoom={16} scrollWheelZoom={false}>
    <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    />
    <Marker position={[-6.190789622146113, 106.8565579856992]}>
      <Popup>
        Jl. Percetakan Negara No.21, RT.19/RW.7, Johar Baru, Kec. Johar Baru, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10560
      </Popup>
    </Marker>
  </MapContainer>
</div>


      
    </div>
    <footer className="footer">
    <div className="footer-container">
      <div className="footer-section">
        <h3>Who we are!</h3>
        <p>
          Aspersindo provides a security printing platform. Synergia security printing companies in Indonesia within a framework of fair competition to become a trusted partner for security document solutions.
        </p>
      </div>
      <div className="footer-section">
        <h3>Popular Posts</h3>
        <ul>
          <li><a href="#about">About us</a></li>
          <li><a href="#team">Members</a></li>
          <li><a href="#gallery">Gallery</a></li>
          <li><a href="#Kontak">Contact us</a></li>
        </ul>
      </div>
      <div className="footer-section">
        <h3>Contact Us</h3>
        <p>
          <a
            href="https://maps.app.goo.gl/x1qnqAq2iPzZYDR3A"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MapPin size={18} style={{ marginRight: "8px" }} />
            Jl. Percetakan Negara No.21, RT.19/RW.7, Johar Baru, Kec. Johar Baru, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10560
          </a>
        </p>
        <p>
          <a
            href="https://wa.me/6281818190888"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Phone size={18} style={{ marginRight: "8px" }} />
            +62 818 1819 0888
          </a>
        </p>
        <p>
          <a
            href="mailto:aspersindo@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Mail size={18} style={{ marginRight: "8px" }} />
            aspersindo@gmail.com
          </a>
        </p>
      </div>
      <div className="footer-section">
        {/* <h3>Social</h3>
        <div className="social-icons">
            <FaFacebookF size={18} style={{ marginRight: "10px" }} />
            <FaTwitter size={18} style={{ marginRight: "10px" }} />
            <FaInstagram size={18} style={{ marginRight: "10px" }} />
            <FaYoutube size={18} style={{ marginRight: "10px" }} />
        </div> */}
      </div>
    </div>
    <div className="copyright">
      <p>All right reserved. 2026 ASPERSINDO</p>
    </div>
  </footer>
  </>
  );
};
